import { useEffect, useState } from "react";
import { fetchStatusCounts } from "../../lib/adminApi";

const TABS = [
  ["", "All"], ["pending", "Pending"], ["approved", "Approved"], ["rejected", "Rejected"], ["hold", "On Hold"], ["blocked", "Blocked"], ["inactive", "Inactive"],
];

export function StatusTabs({ filters, base, value, onChange }) {
  const [counts, setCounts] = useState(null);
  const baseKey = JSON.stringify(base || {});
  useEffect(() => {
    fetchStatusCounts(filters, JSON.parse(baseKey)).then(setCounts).catch(() => setCounts(null));
  }, [filters, baseKey]);
  return (
    <div className="flex flex-wrap gap-2" data-testid="status-tabs">
      {TABS.map(([k, label]) => {
        const active = value === k;
        return (
          <button
            key={k}
            type="button"
            onClick={() => onChange(k)}
            data-testid={`status-tab-${k || "all"}`}
            className={`rounded-full border px-3.5 py-1.5 text-xs font-semibold transition-colors ${active ? "border-[#7A0016] bg-[#7A0016] text-[#F5E6BA]" : "border-[#D4AF37]/60 bg-white text-[#7A0016] hover:bg-[#F5E6BA]/50"}`}
          >
            {label}{counts && ` (${counts[k || "all"] ?? 0})`}
          </button>
        );
      })}
    </div>
  );
}
